export default __webpack_public_path__ + "static/media/Resource-Icons-Fine-Motor-transparent.cd4fcddb.png";